import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "./pages/Landing";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import { Toaster } from "@/components/ui/sonner";
import { installRecaptchaBadgeCSS } from "./lib/recaptcha";
import { trackPageview } from "./lib/analytics";

function PageviewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  useEffect(() => {
    document.title = "Cash 4 Properties — Sell Your House Fast For Cash | Eastern NC";
    installRecaptchaBadgeCSS();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <PageviewTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
